import React from 'react';

const socialSiteData = [
  {
    href: "https://www.facebook.com/sharer/sharer.php?u=https://moapp-source.seabourn.com/voyagetracker/index.html",
    icon: require("../assets/images/share_facebook.svg")
  },
  {
    href: "https://twitter.com/share?url=https://moapp-source.seabourn.com/voyagetracker/index.html",
    icon: require("../assets/images/share_twitter.svg")
  },
  {
    href: "https://www.pinterest.com/seabourncruise/",
    icon: require("../assets/images/share_pintrest.svg")
  },
  {
    href: "https://www.instagram.com/seabourncruise/",
    icon: require("../assets/images/share_instagram.svg")
  },
  {
    href: "https://www.youtube.com/user/Seabourn",
    icon: require("../assets/images/share_youtube.svg")
  },
  {
    href: "https://www.linkedin.com/company/seabourn-cruise-line",
    icon: require("../assets/images/share_linkedin.svg")
  }
];

export const SocialIcons: React.FC = () => {
  return (
    <div className="social-icons">
      {socialSiteData.map((icon) => (
        <a key={icon.href} className="container" href={icon.href} target="_blank" rel="noopener noreferrer">
          <img alt="social icon" className="social-circle" src={icon.icon} />
        </a>
      ))}
    </div>
  );
};

export default SocialIcons;